<template>
<div>

    <div class="mb-2">
        <h3>วัตถุดิบคงเหลือ</h3>
    </div>
    <v-card>
        <v-tabs grow>
            <v-tab @click="page_all(1)">วัตถุดิบทั้งหมด</v-tab>
            <v-tab @click="page_all(2)">วัตถุดิบที่ใกล้หมด</v-tab>
        </v-tabs>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-if="loading_page === false">
            <v-card class="pa-3">
                <div class="col-12 d-flex justify-center">
                    <div class="mr-2" style="width: 400px;">
                        <v-select label="เเหล่งที่มา" :items="source_store_list" item-text="source_name" item-value="id" v-model="source_store_select" hide-details="auto" outlined ></v-select>
                    </div>
                    <div class="ml-2" style="width: 400px;">
                        <v-select  label="ประเภทสินค้า" :items="type_product_list" item-text="name" item-value="id" v-model="type_product_select" hide-details="auto" outlined ></v-select>
                    </div>
                </div>
                <div class="col-12 d-flex justify-center">
                    <v-btn color="#1094C7" class="white--text titlefont_poslist mx-2" type="submit" height="50" width="325" @click="exportPDFMaterial">
                        ดาวน์โหลดรายงาน ไฟล์ PDF
                    </v-btn>

                    <v-btn color="#28ab28" class="white--text titlefont_poslist mx-2" type="submit" height="50" width="325" @click="exportExcelMaterial">
                        ดาวน์โหลดรายงาน ไฟล์ Excel
                    </v-btn>
                </div>

                <v-tabs grow>
                    <v-tab @click="page_detail(source_detail.id)" v-for="(source_detail,index) in source_page_list" :key="index">{{ source_detail.source_name }}</v-tab>
                </v-tabs>

                <div v-for="(type_list,index) in data" :key="index">
                    <v-simple-table v-if="page_id == type_list.id">
                        <thead>
                            <tr>
                                <th class="text-center border_header_detail_material_now">
                                    #
                                </th>
                                <th class="text-center border_header_detail_material_now">
                                    รายการ
                                </th>

                                <th class="text-center border_header_detail_material_now">
                                    Max/Min
                                </th>

                                <th class="text-center border_header_detail_material_now">
                                    จำนวนคงเหลือ
                                </th>

                                <th class="text-center border_header_detail_material_now">
                                    หน่วยนับ
                                </th>
                                <th class="text-center border_header_detail_material_now">
                                    ดูรายละเอียด
                                </th>
                            </tr>
                        </thead>
                        <tbody v-for="(typeDetail,index_type) in type_list.typeList" :key="index_type">
                            <tr>
                                <td colspan="7" class="primary white--text">
                                    {{ typeDetail.type_name }}
                                </td>
                            </tr>
                            <tr v-for="(dataDetail,index_detail) in typeDetail.detailList" :key="index_detail" :class="{ 'row-red': dataDetail.stock < 0 }">
                                <td class="text-center border_header_detail_material_now" width="10%">{{ index_detail + 1 }}</td>
                                <td class="text-left border_header_detail_material_now" width="50%">{{ dataDetail.name }}</td>
                                <td class="text-center border_header_detail_material_now" width="10%">
                                    {{ dataDetail.max }}/{{ dataDetail.min }}
                                </td>
                                <td 
                                    class="text-center border_header_detail_material_now" width="10%"
                                >
                                    {{ dataDetail.stock }}
                                </td>
                                <td class="text-center border_header_detail_material_now" width="10%">
                                    {{ dataDetail.unit_name }}
                                </td>
                                <td class="text-center border_header_detail_material_now" width="10%">
                                    <span class="cursor_material_now" @click="detailMaterial(dataDetail.id)">
                                        <v-icon dark right color="grey">mdi-eye</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
            </v-card>
            <!-- เนื้อหาแต่ละส่วน -->
            <v-dialog v-model="open_stock_material" max-width="900px" persistent>
                <div v-if="loading_page_detail === true">
                    <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                    </v-sheet>
                </div>
                <v-card v-if="loading_page_detail === false">

                    <v-card-title class="justify-space-between">
                        <div>
                            วัตถุดิบ
                        </div>
                        <div class="cursor_material_now" @click="open_stock_material = false">
                            <v-icon>mdi-close</v-icon>
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <v-row>
                            <v-col cols="6">
                                <v-img height="330" max-width="280" class="ma-auto" v-if="imagePreviewURL" :src="imagePreviewURL"></v-img>
                            </v-col>
                            <v-col cols="6">
                                <div class="height_full_detail_material_now d-flex justify-center flex-column">
                                    <div class="d-flex w_half_detail_material_now mb-3">
                                        <div class="text_detail_material_now">
                                            ชื่อวัตถุดิบ : {{ mat_name }}
                                        </div>
                                        <div class="text_detail_material_now">
                                            Barcode : {{ barcode }}
                                        </div>
                                    </div>
                                    <div class="d-flex w_half_detail_material_now mb-3">
                                        <div class="text_detail_material_now">
                                            แหล่งที่มา : {{ mat_source_id.name }}
                                        </div>
                                        <div class="text_detail_material_now">
                                            ประเภท : {{ mat_type_id.name }}
                                        </div>
                                    </div>

                                    <div class="text_detail_material_now line_bottom_detail_material_now pb-3 mb-3">
                                        โซน : {{ outzone_id.toString() }}
                                    </div>

                                    <div class="d-flex w_half_detail_material_now mb-3">
                                        <div class="text_detail_material_now">
                                            จำนวน Max : {{ max }}
                                        </div>
                                        <div class="text_detail_material_now">
                                            จำนวน Min : {{ min }}
                                        </div>
                                    </div>

                                    <div class="d-flex w_half_detail_material_now line_bottom_detail_material_now pb-3 mb-3">
                                        <div class="text_detail_material_now">
                                            ราคา ขนาดย่อย : {{ price }}
                                        </div>
                                        <div class="text_detail_material_now">
                                            หน่วยนับ : {{ unit.name }}
                                        </div>
                                    </div>

                                    <div class="text_detail_material_now mb-3">
                                        หน่วยนับอื่น : {{ unit_other_id ? unit_other_id.name : '-' }}
                                    </div>

                                    <div class="d-flex w_half_detail_material_now">
                                        <div class="text_detail_material_now">
                                            มีจำนวน : {{ per_other_unit ? per_other_unit : '-' }} {{ unit.name }}
                                        </div>
                                        <div class="text_detail_material_now">
                                            ราคา : {{ price_other ? price_other : '-' }}
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>

                    </v-card-text>
                    <v-card-actions>

                    </v-card-actions>

                </v-card>
            </v-dialog>
            <NotFoundDialog v-model="dialogVisible" @retry="clearSearch"/>
        </div>
    </v-card>
    
</div>
</template>

<script>
import {
  HTTP
} from "@/axios.js"
import stockmaterialnow from '@/api/stock/stocklist/stockmaterialnow.js'
import stockmaterial from '@/api/stock/stockmaterial/stockmaterial.js'
import stocktype from '@/api/stock/stocksetting/stocktype.js'
import stocksource from '@/api/stock/stocksetting/stocksource.js'
import stockunit from '@/api/stock/stocksetting/stockunit.js'
import stockzone from '@/api/stock/stocksetting/stockzone.js'
import NotFoundDialog from "@/components/menuadmin/NotFoundDialog.vue";
import before_image from "@/assets/fast-food.png";
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    components: {NotFoundDialog},
    data() {
        return {
            loading_page: true,
            loading_page_detail: true,
            imagePreviewURL: before_image,
            type_list: [],
            source_list: [],
            unit_list: [],
            zone_list: [],
            data: [],
            page_id: null,
            source_page_list: [],
            open_stock_material: false,
            mat_name: null,
            barcode: null,
            mat_source_id: null,
            mat_type_id: null,
            outzone_id: [],
            max: null,
            min: null,
            price: null,
            unit: null,
            per_other_unit: null,
            price_other: null,
            unit_other_id: null,
            source_store_select:0,
            type_product_select:0,
            source_store_list:[{
                source_name:'ทั้งหมด',
                id:0
            }],
            type_product_list:[{
                name:'ทั้งหมด',
                id:0
            }],
            isMatAll:true,
            dialogVisible:false
        }
    },
    methods: {
        async stockMaterialList() {
            this.loading_page = true
            this.source_page_list = []
            this.data = []

            await stockmaterialnow.materialList().then((response) => {
                if (response.data.successful === true) {
                    response.data.sources.forEach((detail, index) => {
                        if (index == 0) {
                            this.page_id = detail.id
                        }
                        this.source_page_list.push({
                            id: detail.id,
                            source_name: detail.source_name,
                        })
                        this.source_store_list.push({
                            id: detail.id,
                            source_name: detail.source_name,
                        })
                    })
                    this.data = response.data.sources
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            await stocktype.typeList().then((response) => {
                if (response.data.successful === true) {
                    this.type_list = response.data.material_type;
                    this.type_list.forEach(el=>{
                        this.type_product_list.push({
                            id:el.id,
                            name:el.name
                        })
                    })
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async stockMaterialMinList() {
            this.loading_page = true
            this.source_page_list = []
            this.data = []

            await stockmaterialnow.materialMinList().then((response) => {
                if (response.data.successful === true) {
                    response.data.sources.forEach((detail, index) => {
                        if (index == 0) {
                            this.page_id = detail.id
                        }
                        this.source_page_list.push({
                            id: detail.id,
                            source_name: detail.source_name,
                        })
                        this.source_store_list.push({
                            id: detail.id,
                            source_name: detail.source_name,
                        })
                    })
                    this.data = response.data.sources
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

        },
        async page_all(type) {
            this.loading_page = true
            this.data = []
            if (type === 1) {
                this.stockMaterialList()
                this.isMatAll = true
            }
            if (type === 2) {
                this.stockMaterialMinList()
                this.isMatAll = false
            }
        },
        async detailMaterial(id) {
            this.loading_page_detail = true
            this.open_stock_material = true
            this.imagePreviewURL = before_image
            this.mat_name = null
            this.barcode = null
            this.mat_source_id = null
            this.mat_type_id = null
            this.outzone_id = []
            this.max = null
            this.min = null
            this.price = null
            this.unit = null
            this.per_other_unit = null
            this.price_other = null
            this.unit_other_id = null

            await stocksource.sourceList().then((response) => {
                if (response.data.successful === true) {
                    this.source_list = response.data.sourceList
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            await stockzone.zoneList().then((response) => {
                if (response.data.successful === true) {
                    this.zone_list = response.data.zone
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })

            await stockunit.unitList().then((response) => {
                if (response.data.successful === true) {
                    this.unit_list = response.data.list
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess') 
                    this.$router.push('/login')
                }
            })

            await stockmaterial.detailMaterial(id).then((response) => {
                if (response.data.successful === true) {
                    this.detail_material = response.data.material
                    this.imagePreviewURL = response.data.material.image
                    this.mat_name = response.data.material.name
                    this.barcode = response.data.material.barcode
                    this.mat_source_id = this.source_list.find((detail) => {
                        return detail.id == response.data.material.source_id
                    })
                    this.mat_type_id = this.type_list.find((detail) => {
                        return detail.id == response.data.material.mat_type_id
                    })
                    this.outzone_id = response.data.material.outzone_id.map((detail) => {
                        return detail.zone
                    })
                    this.max = response.data.material.max
                    this.min = response.data.material.min
                    this.price = response.data.material.price
                    this.unit = this.unit_list.find((detail) => {
                        return detail.id == response.data.material.unit_id
                    })
                    this.per_other_unit = response.data.material.per_other_unit
                    this.price_other = response.data.material.price_other
                    this.unit_other_id = this.unit_list.find((detail) => {
                        return detail.id == response.data.material.unit_other_id
                    })

                    this.loading_page_detail = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async page_detail(id) {
            this.page_id = id
        },
        async exportExcelMaterial() {
            let sourceId = this.source_store_list.find((detail) => {
                return detail.id == this.source_store_select
            })
            let typeId = this.type_product_list.find((detail) => {
                return detail.id == this.type_product_select
            })
            HTTP.post('/stock/export_excel_material', {source_store:sourceId,type_product:typeId,is_mat_all:this.isMatAll},{
            headers: {
                "Authorization": `Bearer ${this.$store.state.token}`
            },
            responseType: 'blob'
            })
            .then((response) => {
            if (response.status == 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const downloadLink = document.createElement('a');
                downloadLink.href = url;
                const nameFIle = this.isMatAll ? 'material_all.xlsx' : 'material_min.xlsx'
                downloadLink.setAttribute('download',nameFIle);
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }

            })
            .catch((error) => {
            if(error.response.status === 404){
                this.dialogVisible = true;
            }
            if (error.response.status === 401) {
                this.$store.commit('logOutSuccess')
                this.$router.push('/login')
            }
            })
        },
        async exportPDFMaterial() {
            let sourceId = this.source_store_list.find((detail) => {
                return detail.id == this.source_store_select
            })
            let typeId = this.type_product_list.find((detail) => {
                return detail.id == this.type_product_select
            })
            HTTP.post('/stock/export_pdf_material', {source_store:sourceId,type_product:typeId,is_mat_all:this.isMatAll},{
            headers: {
                "Authorization": `Bearer ${this.$store.state.token}`
            },
            responseType: 'blob'
            })
            .then((response) => {
            if (response.status == 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const downloadLink = document.createElement('a');
                downloadLink.href = url;
                const nameFIle = this.isMatAll ? 'material_all.pdf' : 'material_min.pdf'
                downloadLink.setAttribute('download',nameFIle);
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }

            })
            .catch((error) => {
            if(error.response.status === 404){
                this.dialogVisible = true;
            }
            if (error.response.status === 401) {
                this.$store.commit('logOutSuccess')
                this.$router.push('/login')
            }
            })
        },
        clearSearch(is_retry){            
            if(is_retry){
                this.dialogVisible = false
                this.source_store_select = 0
                this.type_product_select = 0
                this.stockMaterialList()
            }
        }
    },
    mounted() {
        this.stockMaterialList()
    }
}
</script>

<style scoped>
.cursor_material_now {
    cursor: pointer;
}

.height_full_detail_material_now {
    height: 100%;
    background: #eeeeee;
    border-radius: 10px;
    padding: 10px;
}

.w_half_detail_material_now>div {
    width: 50%;
}

.text_detail_material_now {
    color: #000000;
}

.line_bottom_detail_material_now {
    border-bottom: 1px #000000 solid;
}

.border_header_detail_material_now {
    border: thin solid rgba(0, 0, 0, 0.12);
}
.row-red {
    /* background-color: #ff5252;  */
    color: #ff5252; /* เปลี่ยนตัวอักษรเป็นสีขาว (หรือเปลี่ยนตามความเหมาะสม) */
}

</style>
